import { connect } from 'formik';
import { isEmpty } from 'lodash';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';

import style from './index.module.scss';

const ErrorsReminder = ({ formik }) => {
  if (formik.submitCount === 0 || formik.isValid || isEmpty(formik.errors)) {
    return null;
  }

  return (
    <div className="flex flex-center flex--justify-center">
      <div className={`push--top ${style.component}`}>
        <AdditionalInformation type="error" mt={0} id="errors_reminder">
          {__('Some errors have been found in the form')}
        </AdditionalInformation>
      </div>
    </div>
  );
};

export default connect(ErrorsReminder);
